(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 5557:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(1055);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 1055:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./components/Navbar/Navbar.js + 5 modules
var Navbar = __webpack_require__(7978);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 15 modules
var swiper_react = __webpack_require__(719);
;// CONCATENATED MODULE: ./assets/images/swiper-1.png
/* harmony default export */ var swiper_1 = ({"src":"/_next/static/media/swiper-1.c4277cc8.png","height":1056,"width":1120,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAATlBMVEVMaXH////d+Oj////+/P32//n////////8/v39//7+/v+z4sX////+/v7///////+xzbrH0smb1rJY0Yn///94i3na6N7r+vCYu6SUtp971Gs7AAAAFHRSTlMAIfo18f0VdEDggPxjDqEs+/v7+hLE66QAAAAJcEhZcwAAFiUAABYlAUlSJPAAAABBSURBVHicBcGHAcAgDAMwM0LC7DLQ/v9oJQDdrKcCWCbzCEiZtTI6NPHv56lo+57z2QoX13WuGJCGCKmAmtNyAD9gFgKns0/dsQAAAABJRU5ErkJggg=="});
;// CONCATENATED MODULE: ./assets/images/swiper-2.png
/* harmony default export */ var swiper_2 = ({"src":"/_next/static/media/swiper-2.b718f49a.png","height":1056,"width":1120,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAATlBMVEVMaXH9/f3I7Nb////9//74+/nd7OP+///////8//z////////+//7///////////961J36/Pt5yZnF0MeTpJXz9PL////h9urr+/Gr4cCHBqc9AAAAF3RSTlMAIfs1QPv+/nQS4oBj7KEs/Nz7+vrxBgxFX0AAAAAJcEhZcwAAFiUAABYlAUlSJPAAAABBSURBVHicBcGHEcAwCASwxwYDbql3kP0XjQTAmd0HwJdo3xXe4yy6CFPLF28zTI2Wjxho5d1CK3xLpBhgTDYO4AdU4QJxkZxFUAAAAABJRU5ErkJggg=="});
;// CONCATENATED MODULE: ./assets/images/swiper-3.png
/* harmony default export */ var swiper_3 = ({"src":"/_next/static/media/swiper-3.43e0fd5c.png","height":1056,"width":1120,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAS1BMVEX////4+/n////9/v7///////////9MaXH////6/vyp0rjW7d/6//3///9VwoBujXbGysX8/Pzu+fP////4/vuDjoKPqZbp5ubo//R3VyosAAAAE3RSTlMS8QHfQHz5AG8k/vs1ofv6/F/hUK/caQAAAAlwSFlzAAAWJQAAFiUBSVIk8AAAAEFJREFUeJwFwQcCgCAMBLADOhmiFtT/v9QEWUEEMJRKrHt0oMRZv+S4QvZuYbBI7zOD4SnaUaUDQ9YSUxg5s2v+AVjsAoY15jCLAAAAAElFTkSuQmCC"});
// EXTERNAL MODULE: ./node_modules/react-scroll/modules/index.js
var modules = __webpack_require__(6261);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.min.css
var swiper_min = __webpack_require__(933);
// EXTERNAL MODULE: ./node_modules/swiper/modules/pagination/pagination.min.css
var pagination_min = __webpack_require__(8770);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 90 modules
var swiper_esm = __webpack_require__(1911);
;// CONCATENATED MODULE: ./components/Section/SectionOne.js










var SectionOne = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "pb-[50px] overflow-hidden bg-w-green-100 px-[0px] lg:px-[150px] py-[20px]",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "container mx-auto flex flex-col justify-center items-center lg:flex-row lg:justify-between gap-x-[50px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-[540px] sm:w-[428px] -mt-[70px] sm:-mt-[0px] block lg:hidden",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(swiper_react/* Swiper */.tq, {
                            pagination: {
                                clickable: true
                            },
                            autoplay: {
                                delay: 3000,
                                disableOnInteraction: false
                            },
                            modules: [
                                swiper_esm/* Pagination */.tl,
                                swiper_esm/* Autoplay */.pt
                            ],
                            className: "mySwiper",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                    className: "",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "sm:pb-[27px]",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            layout: "responsive",
                                            priority: true,
                                            src: swiper_1,
                                            alt: "_swiper_1"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "sm:pb-[27px]",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            layout: "responsive",
                                            loading: "lazy",
                                            src: swiper_2,
                                            alt: "_swiper_1"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "sm:pb-[27px]",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            layout: "responsive",
                                            loading: "lazy",
                                            src: swiper_3,
                                            alt: "_swiper_1"
                                        })
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex sm:mt-5 lg:mt-0 px-[56px] lg:px-[0px] flex-col items-center lg:items-start justify-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "font-night text-w-green-300 text-[50px] text-center lg:text-left",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "Wellness that works!"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "pt-[15px] pb-[15px] text-center lg:text-left",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                        className: "pb-[28px]",
                                        children: "Pertahankan talenta terbaik, tingkatkan performa dan produktivitas bisnis Anda. Workay makes everything okay!"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "Solusi kesejahteraan karyawan:"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Link */.rU, {
                                    href: "#section-4",
                                    offset: -80,
                                    spy: true,
                                    smooth: true,
                                    to: "section-4",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: "transition-all hover:scale-110 active:scale-100 bg-w-green-200 rounded-[10px] py-[11px] px-[25px] text-white",
                                        children: "Jadwalkan Demo Sekarang"
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-[560px] hidden lg:block",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(swiper_react/* Swiper */.tq, {
                            pagination: {
                                clickable: true
                            },
                            autoplay: {
                                delay: 3000,
                                disableOnInteraction: false
                            },
                            modules: [
                                swiper_esm/* Pagination */.tl,
                                swiper_esm/* Autoplay */.pt
                            ],
                            className: "mySwiper",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                    className: "",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "pb-[27px]",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            layout: "responsive",
                                            priority: true,
                                            src: swiper_1,
                                            alt: "_swiper_1"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "pb-[27px]",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            layout: "responsive",
                                            loading: "lazy",
                                            src: swiper_2,
                                            alt: "_swiper_1"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "pb-[27px]",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            layout: "responsive",
                                            loading: "lazy",
                                            src: swiper_3,
                                            alt: "_swiper_1"
                                        })
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var Section_SectionOne = (SectionOne);

// EXTERNAL MODULE: ./assets/icons/wa-svg-icon.svg
var wa_svg_icon = __webpack_require__(7983);
// EXTERNAL MODULE: ./assets/icons/wa-icon.png
var wa_icon = __webpack_require__(5003);
// EXTERNAL MODULE: ./components/Footer/Footer.js + 3 modules
var Footer = __webpack_require__(2601);
// EXTERNAL MODULE: ./assets/icons/close-icon.svg
var close_icon = __webpack_require__(4803);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/transitions/transition.js + 4 modules
var transition = __webpack_require__(4080);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/dialog/dialog.js + 24 modules
var dialog = __webpack_require__(787);
;// CONCATENATED MODULE: ./assets/images/slice-image.png
/* harmony default export */ var slice_image = ({"src":"/_next/static/media/slice-image.ce993a3e.png","height":60,"width":2000,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAMAAADU3h9xAAAABlBMVEX///////9VfPVsAAAAAnRSTlNdaU3oN90AAAAJcEhZcwAALEsAACxLAaU9lqkAAAAOSURBVHicY2BgYGAEYQAADwADLwx3QAAAAABJRU5ErkJggg=="});
;// CONCATENATED MODULE: ./assets/images/section-1.png
/* harmony default export */ var section_1 = ({"src":"/_next/static/media/section-1.9be2537c.png","height":615,"width":482,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAMAAADtGH4KAAAATlBMVEVMaXGrtaw/j1tLhF1XvH9DyHkds1onwGUsxF5xz6Aqwm1MrHE+pWemuao8tGx6upLb4NsqjU4EaiqTyKY8vHAxyW66wbpt2Jnc4dwrvma9cPHUAAAAFXRSTlMA+sD8+mNTMw8IKqYlrPSUwIU8/Pk4WbyBAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAN0lEQVR4nBXF2xaAEBRAwS33UFFH/P+PWuZlgJwinM4WwMqvGngxve50PwJ+arWTdzwR913mDgsuRQHep9pUcQAAAABJRU5ErkJggg=="});
;// CONCATENATED MODULE: ./assets/images/section-2.png
/* harmony default export */ var section_2 = ({"src":"/_next/static/media/section-2.1ff90027.png","height":500,"width":583,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAMAAAACh/xsAAAANlBMVEUjPTElTDo/yngnJycdHh1HuHUwMDACBAIJCgoXTCwWf0I6rWknQDI+sm0vX0NAxHQtSzk/nmUXneB5AAAAEnRSTlMBHnNUPBzwEyYLcIPJfrpPu3T+9dHbAAAACXBIWXMAABYlAAAWJQFJUiTwAAAANUlEQVR4nB3BCQ6AMAwDwW1JYoer8P/PIjED0Hvz2841ExhV9zGBqOe9Egl3DggaSdCyw+YDIRIBIrK16+8AAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./components/Section/SectionTwo.js





var SectionTwo = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "pt-[70px]",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "container mx-auto",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col items-center justify-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "text-center md:px-[0px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-[48px] font-bold text-w-green-200",
                                    children: "Mengapa pilih Workay?"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-full md:w-[657px] mt-[30px]",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    children: "Perfoma karyawan berpengaruh sangat tinggi terhadap produktivitas perusahaan. Bersama Workay, hapuskan stres finansial karyawan Anda!"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "px-[30px] lg:px-[150px] w-full mt-[65px]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col items-center justify-center rounded-b-[20px] lg:rounded-bl-[0px] lg:rounded-r-[20px] border-[1px] border-w-green-200",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "w-full lg:w-[535px] py-[25px] text-center bg-w-green-100 border-[1px] border-w-green-200",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "w-full",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                layout: "responsive",
                                                src: slice_image,
                                                alt: "_sliceImage"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "pb-[23px] pt-[8px]",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "font-night text-outline text-w-green-300 text-[24px]",
                                                children: "Make them stay, your way!"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "w-full",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                layout: "responsive",
                                                src: slice_image,
                                                alt: "_sliceImage"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-col gap-y-[35px] lg:flex-row pt-[40px] lg:pt-[25px] pb-[61px] gap-x-[70px] px-[35px] lg:pl-[90px] lg:pr-[60px] justify-center items-center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "w-[153px] h-[195px] small-screen:w-[185px] small-screen:h-[235px] md:w-[241px] md:h-[308px]",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    layout: "responsive",
                                                    objectFit: "cover",
                                                    src: section_1,
                                                    alt: "_sectionimage"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                        children: [
                                                            "Dengan program ",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                                children: "wellness-oriented"
                                                            }),
                                                            " Workay, bantu karyawan berkembang dan memaksimalkan potensinya."
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "mt-4",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        children: "Kurangi turnover rate perusahaan, dan tingkatkan loyalitas karyawan dengan memberikan benefit sesuai kebutuhan finansialnya."
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "mt-4",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                                children: "[Not-so-fun fact]"
                                                            }),
                                                            " Karyawan yang memiliki stres finansial, 2X lebih sering mencari pekerjaan lain, di mana 76% lebih tertarik untuk bekerja di perusahaan yang mementingkan financial wellness karyawannya."
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "px-[30px] lg:px-[150px] w-full mt-[50px]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col items-center justify-center rounded-b-[20px] lg:rounded-bl-[0px] lg:rounded-r-[20px] border-[1px] border-w-green-200",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "w-full lg:w-[535px] py-[25px] text-center bg-w-green-100 border-[1px] border-w-green-200",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "w-full",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                layout: "responsive",
                                                src: slice_image,
                                                alt: "_sliceImage"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "pb-[23px] pt-[8px]",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "font-night text-outline text-w-green-300 text-[24px]",
                                                children: "Financial stress, no more!"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "w-full",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                layout: "responsive",
                                                src: slice_image,
                                                alt: "_sliceImage"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-col gap-y-[35px] lg:flex-row pt-[45px] pb-[61px] lg:gap-x-[25px] xl:gap-x-[36px] px-[35px] lg:pl-[90px] lg:pr-[42px] justify-center items-center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "lg:hidden w-[190px] h-[163px] small-screen:w-[275px] small-screen:h-[235px] lg:w-[222px] lg:h-[180px] xl:w-[292px] xl:h-[250px]",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    layout: "responsive",
                                                    objectFit: "cover",
                                                    src: section_2,
                                                    alt: "_sectionimage"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                        children: [
                                                            "Banyak karyawan yang masih menghabiskan waktu kerjanya untuk mengatasi masalah finansial. ",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                                children: "Stres finansial"
                                                            }),
                                                            " dapat mempengaruhi kesehatan mental, rumah tangga, dan tingkat kehadiran kerja, lho!"
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "grid lg:grid-cols-3 lg:gap-x-[35px] gap-y-[15px] pt-[25px] grid-cols-1 justify-between items-center lg:items-start lg:h-full",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "pb-[25px] gap-x-[11px] md:gap-x-[20px] lg:gap-y-[17px] flex flex-row lg:flex-col items-center lg:h-full bg-w-green-100 overflow-hidden pt-[35px] px-[15px] md:px-[20px] rounded-[20px]",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "rounded-full flex flex-row items-center justify-center bg-w-green-200 p-5 w-[62px] h-[62px] lg:w-[106px] lg:h-[106px] ",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                        className: "flex flex-row items-center justify-center",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                className: "text-white font-bold text-[24px] lg:text-[40px]",
                                                                                children: "72"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                className: "text-white font-bold ml-1 mt-2 text-[13px] lg:text-[20px]",
                                                                                children: "%"
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    className: "lg:text-center",
                                                                    children: "Karyawan belum mempunyai dana darurat"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "pb-[25px] gap-x-[11px] md:gap-x-[20px] lg:gap-y-[17px] flex flex-row lg:flex-col items-center lg:h-full bg-w-green-100 overflow-hidden pt-[35px] px-[15px] md:px-[20px] rounded-[20px]",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "rounded-full flex flex-row items-center justify-center bg-w-green-200 p-5 w-[62px] h-[62px] lg:w-[106px] lg:h-[106px] ",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                        className: "flex flex-row items-center justify-center",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                className: "text-white font-bold text-[24px] lg:text-[40px]",
                                                                                children: "73"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                className: "text-white font-bold ml-1 mt-2 text-[13px] lg:text-[20px]",
                                                                                children: "%"
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    className: "lg:text-center",
                                                                    children: "Karyawan bilang gaji mereka habis sebelum gajian berikutnya"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "pb-[25px] gap-x-[11px] md:gap-x-[20px] lg:gap-y-[17px] flex flex-row lg:flex-col items-center lg:h-full bg-w-green-100 overflow-hidden pt-[35px] px-[15px] md:px-[20px] rounded-[20px]",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "rounded-full flex flex-row items-center justify-center bg-w-green-200 p-5 w-[62px] h-[62px] lg:w-[106px] lg:h-[106px] ",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                        className: "flex flex-row items-center justify-center",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                className: "text-white font-bold text-[24px] lg:text-[40px]",
                                                                                children: "44"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                className: "text-white font-bold ml-1 mt-2 text-[13px] lg:text-[20px]",
                                                                                children: "%"
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    className: "lg:text-center",
                                                                    children: "Karyawan mencari pekerjaan tambahan untuk memenuhi kebutuhan bulanan"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "mt-[35px]",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                        children: [
                                                            "Menanamkan ",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                                children: "literasi keuangan"
                                                            }),
                                                            " pada karyawan dapat dimulai dengan dukungan penuh dari perusahaan Anda. Begini caranya!"
                                                        ]
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "hidden lg:block lg:w-[222px] lg:h-[180px] xl:w-[292px] xl:h-[250px]",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    layout: "responsive",
                                                    objectFit: "cover",
                                                    src: section_2,
                                                    alt: "_sectionimage"
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var Section_SectionTwo = (SectionTwo);

;// CONCATENATED MODULE: ./assets/images/fitur-1.png
/* harmony default export */ var fitur_1 = ({"src":"/_next/static/media/fitur-1.583fea9b.png","height":842,"width":892,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAVFBMVEVMaXHG7teF2ae66s39/P39//7///98u4Px9fJy1Zqg17X///+6urb+/v7+/v562KD4+/ui5b171qD+/v7////1//r6+vv////r//XJ69eW6rjS39WlsxyIAAAAF3RSTlMA8/3N+ZF6B/0k/E79YA5Jqb/93yg3+tp2aNUAAAAJcEhZcwAAFiUAABYlAUlSJPAAAABASURBVHicBcGFEcAwDACxD9qhpngu7L9nJeBM6UKgRTPLg+UwVdVMtmjW+yDFZ6/1a8h6e/8GgbI5FyYgUooIP2PrApVURrN1AAAAAElFTkSuQmCC"});
;// CONCATENATED MODULE: ./assets/images/fitur-2.png
/* harmony default export */ var fitur_2 = ({"src":"/_next/static/media/fitur-2.9791d624.png","height":842,"width":892,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAV1BMVEVkZGT9/v3i8Ojp+e/1/Pjp+O/w9fXw9/f8//739/b////B4M2ssqzo+e79//3E08hzzJZ5rItx0Zj///+TzamXq5v////////////U7N7///9TkGfw6exBKIzBAAAAGnRSTlMBn+woev0ZCPqVTv4ovsj+/P393/37Z1k39OMODnIAAAAJcEhZcwAAFiUAABYlAUlSJPAAAABBSURBVHicFcGJEYAgDADB400AFX+daP91Ou4CoZQbgapmKZ7I1o6UNBJtf161C6d9aWoVcTavNgnk4v0Y+A0Z+ABleQKUUNhASAAAAABJRU5ErkJggg=="});
;// CONCATENATED MODULE: ./assets/icons/next-icon.svg
/* harmony default export */ var next_icon = ({"src":"/_next/static/media/next-icon.1b03d3a4.svg","height":113,"width":65});
;// CONCATENATED MODULE: ./assets/icons/prev-icon.svg
/* harmony default export */ var prev_icon = ({"src":"/_next/static/media/prev-icon.ba5adebd.svg","height":113,"width":65});
;// CONCATENATED MODULE: ./components/Section/SectionThree.js











var SectionThree = function() {
    var swiperRef = (0,react.useRef)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "mt-[110px] lg:mt-[160px] bg-w-green-100",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "container mx-auto flex flex-col items-center justify-center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "text-center pt-[70px] px-[30px] md:px-[0px]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-[48px] font-bold text-w-green-200",
                                children: "Fitur Produk"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: " text-[24px] font-night text-outline-2",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                children: "Wellness-oriented Workay"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "w-full mt-[80px]",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(swiper_react/* Swiper */.tq, {
                        onSwiper: function(swiper) {
                            swiperRef.current = swiper;
                        },
                        spaceBetween: 50,
                        pagination: {
                            clickable: true
                        },
                        modules: [
                            swiper_esm/* Pagination */.tl,
                            swiper_esm/* Autoplay */.pt
                        ],
                        className: "mySwiper2 gap-5",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex md:px-[150px] pb-[132px] lg:pb-[100px] flex-col lg:flex-row gap-x-[56px] justify-center items-center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "w-[400px] h-auto small-screen:w-[445px] small-screen:h-[420px]",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                layout: "responsive",
                                                objectFit: "cover",
                                                src: fitur_1,
                                                alt: "fitur_image"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex px-[35px] md:px-[0px] flex-col lg:w-[400px] xl:w-[325px]",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "w-full py-2 bg-white border-[2px] text-w-green-200 border-w-green-200 rounded-[20px] text-center",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: " font-bold",
                                                        children: "Advanced Salary"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "mt-[25px]",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: "Karyawan dapat mengakses gaji bulanan lebih awal, kapan pun dan di mana pun. Bantu karyawan:"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                            className: "list-disc list-inside ml-10 mt-5 list-section",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                    children: "Meredakan masalah stres finansial yang dimiliki"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                    children: "Mengindari mengambil alternatif pinjaman berbunga tinggi"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                    children: "Menjaga cash flow perusahaan"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                    children: "Mempertahankan karyawan terbaik"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                            className: "mt-5",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                                    children: "*Penarikan Advance Salary"
                                                                }),
                                                                " maximum 80% dari gaji bulanan."
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "hidden lg:block hover:scale-110 active:scale-100 ml-[50px] xl:ml-[120px]",
                                            onClick: function() {
                                                return swiperRef.current.slideNext();
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                layout: "fixed",
                                                src: next_icon,
                                                alt: "next-icon"
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex md:px-[150px] pb-[132px] lg:pb-[100px] flex-col lg:flex-row gap-x-[56px] justify-start items-center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "hidden lg:block hover:scale-110 active:scale-100 mr-[50px] xl:mr-[100px]",
                                            onClick: function() {
                                                return swiperRef.current.slidePrev();
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                layout: "fixed",
                                                src: prev_icon,
                                                alt: "next-icon"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "w-[400px] h-auto mb-5 small-screen:w-[445px] small-screen:h-[420px]",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                layout: "responsive",
                                                objectFit: "cover",
                                                src: fitur_2,
                                                alt: "fitur_image"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex px-[35px] md:px-[0px] flex-col lg:w-[400px] xl:w-[325px]",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "w-full py-2 bg-white border-[2px] text-w-green-200 border-w-green-200 rounded-[20px] text-center",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: " font-bold",
                                                        children: "Employee Rewards"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "mt-[25px]",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: "WERK (Warung Employee Reward Karyawan) agar karyawan terus onboard, jangan sampai mereka bored! Bantu karyawan mengelola keuangan dengan deal-deal menarik untuk memenuhi kebutuhan mereka."
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "mt-5",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    className: "font-bold",
                                                                    children: "Benefit untuk perusahaan:"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    children: "Mudah mengatur budget employee wellness setiap karyawan yang digunakan untuk meningkatkan produktivitas, kesehatan, dan kebahagiaan karyawan."
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "mt-5",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    className: "font-bold",
                                                                    children: "Benefit untuk karyawan:"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    children: "Nikmati diskon khusus dari berbagai merchant Workay, seperti voucher restoran, keanggotaan gym, training, paket data, hingga kebutuhan sehari-hari."
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var Section_SectionThree = (SectionThree);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(1799);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(4051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/listbox/listbox.js + 8 modules
var listbox = __webpack_require__(5274);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(7536);
;// CONCATENATED MODULE: ./assets/icons/selector-icon.svg
/* harmony default export */ var selector_icon = ({"src":"/_next/static/media/selector-icon.9ed4ee40.svg","height":8,"width":14});
// EXTERNAL MODULE: ./node_modules/reaptcha/dist/index.esm.js
var dist_index_esm = __webpack_require__(6944);
;// CONCATENATED MODULE: ./components/Section/SectionFour.js












var dataTipe = [
    "Saya ingin bertanya tentang Workay untuk perusahaan saya/orang lain",
    "Saya ingin bermitra dengan Workay sebagai vendor rewards management"
];
var SiteKey = "6Lf4CBshAAAAAPceCHQJ5MBW5-ZusZHRHNwHcWzZ";
var getWindowSize = function() {
    var ref =  true && window, innerWidth = ref.innerWidth, innerHeight = ref.innerHeight;
    return {
        innerWidth: innerWidth,
        innerHeight: innerHeight
    };
};
var SectionFour = function(param) {
    var openModal = param.openModal;
    var ref = (0,react.useState)(), selected = ref[0], setSelected = ref[1];
    var ref1 = (0,index_esm/* useForm */.cI)(), control = ref1.control, handleSubmit = ref1.handleSubmit, reset = ref1.reset, register = ref1.register, errors = ref1.formState.errors;
    var refCaptcha = (0,react.useRef)();
    var ref2 = (0,react.useState)(""), captcha = ref2[0], setCaptcha = ref2[1];
    var ref3 = (0,react.useState)(false), recaptchaNeeded = ref3[0], setRecaptchaNeeded = ref3[1];
    var ref4 = (0,react.useState)(false), loading = ref4[0], setLoading = ref4[1];
    var ref5 = (0,react.useState)({
        status: false,
        message: ""
    }), err = ref5[0], setErr = ref5[1];
    var ref6 = (0,react.useState)(getWindowSize()), windowSize = ref6[0], setWindowSize = ref6[1];
    (0,react.useEffect)(function() {
        var handleWindowResize = function() {
            setWindowSize(getWindowSize());
        };
        window.addEventListener("resize", handleWindowResize);
        return function() {
            window.removeEventListener("resize", handleWindowResize);
        };
    }, []);
    var handleOnSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(e) {
            var dataBody;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!captcha) {
                            _ctx.next = 8;
                            break;
                        }
                        setLoading(true);
                        setErr({
                            status: false,
                            message: ""
                        });
                        dataBody = {
                            captcha: captcha,
                            data: e
                        };
                        _ctx.next = 6;
                        return axios_default().post("/api/v1/subscriptions", dataBody, {
                            headers: {
                                Accept: "application/json",
                                "Content-Type": "application/json"
                            }
                        }).then(function(res) {
                            if (res.data.status) {
                                openModal();
                                setLoading(false);
                                setSelected(null);
                                reset();
                                refCaptcha.current.reset();
                                setCaptcha("");
                            }
                        }).catch(function(err) {
                            setErr({
                                status: true,
                                message: "Ada kesalahan, coba lagi"
                            });
                            setLoading(false);
                            setCaptcha("");
                            refCaptcha.current.reset();
                        });
                    case 6:
                        _ctx.next = 9;
                        break;
                    case 8:
                        {
                            setErr({
                                status: true,
                                message: "Captcha belum dicentang"
                            });
                        }
                    case 9:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleOnSubmit(e) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "pt-[65px] small-screen:pt-[131px] md:pt-[162px]",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "container mx-auto flex gap-y-[56px] md:pl-[160px] md:pr-[150px] pb-[130px] flex-col lg:flex-row gap-x-[100px] xl:gap-x-[160px] justify-between items-center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col text-center lg:text-left",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "px-[20px] md:p-0 font-bold text-[48px] text-w-green-200",
                                children: "Bersama Workay,"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "px-[45px] md:p-0 font-night text-[24px] text-outline-2",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                children: "Wujudkan Kesejahteraan Karyawan & Pertahankan talenta terbaik Anda!"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "px-[57px] md:p-0 mt-2",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                children: "Siap menjadikan financial wellness bagian dari perusahaan Anda? Isi formulir di samping/di bawah, tim representatif Workay akan segera menghubungi Anda."
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex flex-col w-full px-[38px] md:p-0",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
                        onSubmit: handleSubmit(handleOnSubmit),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col w-full",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "mb-[30px]",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                            className: "block text-w-green-200 font-bold mb-1",
                                            children: "Nama"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, register("name", {
                                            required: true,
                                            onChange: function() {
                                                setErr({
                                                    status: false,
                                                    message: ""
                                                });
                                                setRecaptchaNeeded(true);
                                            }
                                        })), {
                                            className: "".concat(errors.name ? "border-red-400 bg-red-100" : "border-w-green-200 bg-w-green-100", " appearance-none border rounded-[10px] w-full py-3 px-4 leading-tight focus:outline-none focus:shadow-outline"),
                                            type: "text",
                                            placeholder: "Masukan nama"
                                        }))
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "mb-[30px]",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                            className: "block text-w-green-200 font-bold mb-1",
                                            children: "Email"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, register("email", {
                                            required: true,
                                            pattern: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/,
                                            onChange: function() {
                                                setErr({
                                                    status: false,
                                                    message: ""
                                                });
                                            }
                                        })), {
                                            className: "".concat(errors.email ? "border-red-400 bg-red-100" : "border-w-green-200 bg-w-green-100", " appearance-none border rounded-[10px] w-full py-3 px-4 leading-tight focus:outline-none focus:shadow-outline"),
                                            type: "text",
                                            placeholder: "Masukan email"
                                        }))
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "mb-[30px]",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                            className: "block text-w-green-200 font-bold mb-1",
                                            children: "Nomor Whatsapp"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, register("number_phone", {
                                            required: true,
                                            valueAsNumber: false,
                                            onChange: function() {
                                                setErr({
                                                    status: false,
                                                    message: ""
                                                });
                                            }
                                        })), {
                                            className: "".concat(errors.number_phone ? "border-red-400 bg-red-100" : "border-w-green-200 bg-w-green-100", " appearance-none border rounded-[10px] w-full py-3 px-4 leading-tight focus:outline-none focus:shadow-outline"),
                                            type: "number",
                                            placeholder: "Masukan nomor whatsapp"
                                        }))
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "mb-[30px]",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
                                            control: control,
                                            defaultValue: "",
                                            name: "tipe",
                                            rules: {
                                                required: true
                                            },
                                            render: function(param) {
                                                var onChange = param.field.onChange;
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(listbox/* Listbox */.R, {
                                                    value: selected,
                                                    onChange: function(e) {
                                                        onChange(e);
                                                        setSelected(e);
                                                        setErr({
                                                            status: false,
                                                            message: ""
                                                        });
                                                    },
                                                    children: function(param) {
                                                        var open = param.open;
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "relative mt-1",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(listbox/* Listbox.Label */.R.Label, {
                                                                    className: "block text-w-green-200 font-bold mb-1",
                                                                    children: "Tipe"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(listbox/* Listbox.Button */.R.Button, {
                                                                    className: "relative overflow-hidden justify-between items-center w-full text-left cursor-default appearance-none ".concat(open && "border-b-0", " border ").concat(errors.tipe ? "border-red-400 bg-red-100" : "border-w-green-200 bg-w-green-100", " rounded-[10px] transition-all ").concat(open && "rounded-b-none", " leading-tight focus:outline-none focus:shadow-outline"),
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            className: "block py-3 px-4 pr-[50px] ".concat(selected ? "" : "opacity-[0.6]"),
                                                                            children: selected ? selected : "Pilih pertanyaan"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            className: "pointer-events-none absolute w-[45px] h-full top-0 right-0 ",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                className: "".concat(errors.tipe ? "bg-red-400 " : "bg-w-green-200", " flex justify-center items-center w-full h-full"),
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                                    className: "transition-all ".concat(open && "rotate-180"),
                                                                                    layout: "fixed",
                                                                                    src: selector_icon,
                                                                                    alt: "_selector-icon"
                                                                                })
                                                                            })
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition */.u, {
                                                                    as: react.Fragment,
                                                                    leave: "transition ease-in duration-100",
                                                                    leaveFrom: "opacity-100",
                                                                    leaveTo: "opacity-0",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(listbox/* Listbox.Options */.R.Options, {
                                                                        className: "absolute max-h-60 w-full overflow-auto rounded-b-[10px] bg-w-green-100 border border-t-0 border-w-green-200 z-[9999]",
                                                                        children: dataTipe.map(function(tipe, personIdx) {
                                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(listbox/* Listbox.Option */.R.Option, {
                                                                                className: function(param) {
                                                                                    var active = param.active;
                                                                                    return "relative cursor-default select-none py-2 pl-3 pr-[50px] ".concat(active && "bg-w-green-200 text-white");
                                                                                },
                                                                                value: tipe,
                                                                                children: function(param) {
                                                                                    var selected = param.selected;
                                                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                            className: "block ",
                                                                                            children: tipe
                                                                                        })
                                                                                    });
                                                                                }
                                                                            }, personIdx);
                                                                        })
                                                                    })
                                                                })
                                                            ]
                                                        });
                                                    }
                                                });
                                            }
                                        }),
                                        (errors.name || errors.email || errors.number_phone || errors.tipe || err.status) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "block text-red-400 font-bold mt-5",
                                            children: err.message ? err.message : "Informasi belum lengkap"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "".concat(recaptchaNeeded && "mb-[20px]"),
                                    children: recaptchaNeeded && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* default */.Z, {
                                        id: "captcha",
                                        ref: refCaptcha,
                                        sitekey: SiteKey,
                                        size: windowSize.innerWidth < 400 ? "compact" : "normal",
                                        onVerify: function(e) {
                                            setCaptcha(e);
                                            setErr({
                                                status: false,
                                                message: ""
                                            });
                                        },
                                        onExpire: function() {
                                            return setCaptcha("");
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex flex-row items-center justify-center lg:items-start lg:justify-start",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                        type: "submit",
                                        disabled: loading || captcha.length == 0,
                                        className: "disabled:bg-w-green-200-disable disabled:text-gray-400 transition-all flex flex-row justify-between items-center hover:scale-110 active:scale-100 bg-w-green-200 rounded-[10px] py-[11px] px-[60px] text-white",
                                        children: [
                                            loading && /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                                "aria-hidden": "true",
                                                className: "mr-2 w-5 h-5 text-gray-200 animate-spin dark:text-gray-600 fill-w-green-100",
                                                viewBox: "0 0 100 101",
                                                fill: "none",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z",
                                                        fill: "currentColor"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z",
                                                        fill: "currentFill"
                                                    })
                                                ]
                                            }),
                                            loading ? "loading..." : "Kirim"
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var Section_SectionFour = (SectionFour);

;// CONCATENATED MODULE: ./assets/icons/success.svg
/* harmony default export */ var success = ({"src":"/_next/static/media/success.32e1a390.svg","height":211,"width":220});
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
;// CONCATENATED MODULE: ./seo.config.js
var seo = {
    description: "Workay adalah platform kesehatan finansial untuk karyawan dan membantu perusahaan anda mempertahankan pekerja terbaik.",
    title: "Workay | Gaji Instan Karyawan Perusahaan dan Rewards",
    keywords: "Workay, workay, karyawan, bisnis, produktivitas, rewards, Bisnis, Finansial, finansial, perusahaan, untuk, Produktivitas, Perusahaan, Kesehatan,",
    image: "https://assetpublic.workay.id/logo-workay.png"
};
/* harmony default export */ var seo_config = (seo);

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./pages/index.js


















var Home = function() {
    var modalRef = (0,react.useRef)(null);
    var modalSuccessRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(false), isOpen = ref[0], setIsOpen = ref[1];
    var ref1 = (0,react.useState)(false), successOpen = ref1[0], setSuccessOpen = ref1[1];
    var closeModalSucess = function() {
        setSuccessOpen(false);
    };
    var openModalSuccess = function() {
        setSuccessOpen(true);
    };
    var closeModal = function() {
        setIsOpen(false);
    };
    var openModal = function() {
        setIsOpen(true);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "font-roboto text-w-text",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                    rel: "workay_icon",
                    href: "/favicon.ico"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                defaultTitle: seo_config.title,
                description: seo_config.description,
                canonical: "https://www.workay.id",
                openGraph: {
                    type: "website",
                    site_name: "Workay",
                    title: seo_config.title,
                    description: seo_config.description,
                    images: [
                        {
                            url: seo_config.image
                        }, 
                    ]
                },
                twitter: {
                    handle: "@handle",
                    site: "@site",
                    cardType: "summary_large_image"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar/* default */.Z, {}),
            isOpen || successOpen ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                onClick: openModal,
                className: "fixed h-[40x] w-[40px] transition-all hover:scale-110 active:scale-100 right-[26px] md:right-[100px] lg:right-[150px] bottom-10 md:bottom-20 z-[8]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    layout: "responsive",
                    src: wa_icon/* default */.Z,
                    alt: "_wa-icon"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Element */.W_, {
                name: "section-1",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Section_SectionOne, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Element */.W_, {
                name: "section-2",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Section_SectionTwo, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Element */.W_, {
                name: "section-3",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Section_SectionThree, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Element */.W_, {
                name: "section-4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Section_SectionFour, {
                    openModal: openModalSuccess
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* default */.Z, {
                openModal: openModal
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition */.u, {
                appear: true,
                show: isOpen,
                as: react.Fragment,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dialog/* Dialog */.V, {
                    initialFocus: modalRef,
                    as: "div",
                    className: "relative z-10",
                    onClose: closeModal,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition.Child */.u.Child, {
                            as: react.Fragment,
                            enter: "ease-out duration-300",
                            enterFrom: "opacity-0",
                            enterTo: "opacity-100",
                            leave: "ease-in duration-200",
                            leaveFrom: "opacity-100",
                            leaveTo: "opacity-0",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "fixed inset-0 bg-black bg-opacity-25"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "fixed inset-0 overflow-y-auto",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex min-h-full items-center justify-center p-5 text-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition.Child */.u.Child, {
                                    as: react.Fragment,
                                    enter: "ease-out duration-300",
                                    enterFrom: "opacity-0 scale-95",
                                    enterTo: "opacity-100 scale-100",
                                    leave: "ease-in duration-200",
                                    leaveFrom: "opacity-100 scale-100",
                                    leaveTo: "opacity-0 scale-95",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog/* Dialog.Panel */.V.Panel, {
                                        className: "w-full py-[60px] max-w-3xl transform overflow-hidden rounded-[15px] bg-white p-6 text-left align-middle shadow-xl transition-all",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex gap-x-[24px] flex-col md:flex-row justify-center items-center",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    onClick: closeModal,
                                                    className: "w-[42px] flex hover:scale-110 active:scale-100 justify-center items-center h-[42px] absolute top-5 right-5",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        src: close_icon/* default */.Z,
                                                        alt: "close-icon"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "w-[132px] h-[132px] mb-[35px] md:md-0 md:w-[211px] md:h-[211px]",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        src: wa_svg_icon/* default */.Z,
                                                        alt: "_wa-icon"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex flex-col justify-center items-center",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "font-roboto text-center text-w-text w-[262px] mb-5",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                children: "Kamu akan terhubung dengan tim Layanan Pelanggan Workay"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://wa.me/+6281219987890",
                                                                target: "_blank",
                                                                rel: "noreferrer",
                                                                ref: modalRef,
                                                                className: "focus:outline-none transition-all hover:scale-110 active:scale-100 bg-w-green-200 rounded-[10px] py-[11px] px-[100px] text-white",
                                                                children: "Lanjut"
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition */.u, {
                appear: true,
                show: successOpen,
                as: react.Fragment,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dialog/* Dialog */.V, {
                    initialFocus: modalSuccessRef,
                    as: "div",
                    className: "relative z-10",
                    onClose: closeModalSucess,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition.Child */.u.Child, {
                            as: react.Fragment,
                            enter: "ease-out duration-300",
                            enterFrom: "opacity-0",
                            enterTo: "opacity-100",
                            leave: "ease-in duration-200",
                            leaveFrom: "opacity-100",
                            leaveTo: "opacity-0",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "fixed inset-0 bg-black bg-opacity-25"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "fixed inset-0 overflow-y-auto",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex min-h-full items-center justify-center p-5 text-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition.Child */.u.Child, {
                                    as: react.Fragment,
                                    enter: "ease-out duration-300",
                                    enterFrom: "opacity-0 scale-95",
                                    enterTo: "opacity-100 scale-100",
                                    leave: "ease-in duration-200",
                                    leaveFrom: "opacity-100 scale-100",
                                    leaveTo: "opacity-0 scale-95",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog/* Dialog.Panel */.V.Panel, {
                                        className: "w-full py-[60px] max-w-3xl transform overflow-hidden rounded-[15px] bg-white p-6 text-left align-middle shadow-xl transition-all",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex gap-x-[60px] flex-col md:flex-row justify-center items-center",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    onClick: closeModalSucess,
                                                    className: "w-[42px] h-[42px] flex hover:scale-110 active:scale-100 justify-center items-center absolute top-5 right-5",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        src: close_icon/* default */.Z,
                                                        alt: "close-icon"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "w-[157px] h-[157px] mb-[35px] md:md-0 md:w-[211px] md:h-[211px]",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        src: success,
                                                        alt: "_wa-icon"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex flex-col justify-center items-center",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "text-w-green-200 text-center leading-[50px] text-[48px] font-bold",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                children: "Data Terkirim"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            ref: modalSuccessRef,
                                                            className: "font-roboto px-[30px] md:px-[0] text-center mt-3 text-w-text w-full md:w-[262px] ",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                children: "Silahkan tunggu, tim representatif kami akan menghubungi Anda"
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var pages = (Home);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9,564,327,774,888,179], function() { return __webpack_exec__(5557); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);